var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement(
      "title",
      null,
      "important"
    ),
    React.createElement("path", { fill: "#F15757", d: "M24 3a21 21 0 1 0 21 21A21 21 0 0 0 24 3zm3 32.08c0 1.81-.56 2.92-2.42 2.92h-.7A2.67 2.67 0 0 1 21 35.08v-.58c0-1.81 1.05-2.5 2.88-2.5h.7c1.86 0 2.42.7 2.42 2.5v.57zm.66-20.88l-1.6 13.14a3.59 3.59 0 0 1-.53 1.34 1 1 0 0 1-1 .33h-.61a.93.93 0 0 1-.9-.3 3 3 0 0 1-.53-1.24l-1.6-13.12a2.77 2.77 0 0 1 .45-2.58 2.85 2.85 0 0 1 2.38-.77h1a3 3 0 0 1 2.46.74 2.53 2.53 0 0 1 .48 2.45z" }),
    React.createElement("path", { fill: "#FFF", d: "M24 0a24 24 0 1 0 24 24A24 24 0 0 0 24 0zm0 45a21 21 0 1 1 21-21 21 21 0 0 1-21 21z" }),
    React.createElement("path", { fill: "#FFF", d: "M24.58 32h-.7c-1.83 0-2.88.7-2.88 2.5v.57A2.67 2.67 0 0 0 23.88 38h.7c1.86 0 2.42-1.12 2.42-2.92v-.58c0-1.8-.56-2.5-2.42-2.5zm.17-21h-1a2.85 2.85 0 0 0-2.38.75 2.77 2.77 0 0 0-.45 2.58l1.6 13.12A3 3 0 0 0 23 28.7a.93.93 0 0 0 .9.3h.62a1 1 0 0 0 1-.33 3.59 3.59 0 0 0 .53-1.34l1.6-13.14a2.53 2.53 0 0 0-.45-2.46 3 3 0 0 0-2.45-.73z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/important.svg